import { render, staticRenderFns } from "./IssueAddEditPopupCoreContent.vue?vue&type=template&id=0e026134&scoped=true"
import script from "./IssueAddEditPopupCoreContent.vue?vue&type=script&lang=js"
export * from "./IssueAddEditPopupCoreContent.vue?vue&type=script&lang=js"
import style0 from "./IssueAddEditPopupCoreContent.vue?vue&type=style&index=0&id=0e026134&prod&lang=scss"
import style1 from "./IssueAddEditPopupCoreContent.vue?vue&type=style&index=1&id=0e026134&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e026134",
  null
  
)

export default component.exports